import React from 'react'
import { Close } from '../../icons'
import styles from './Chip.module.sass'

interface Props {
  label?: string
  selected?: boolean
  showIcon?: boolean
  onClick?: (v: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
}

const Chip = (props: Props) => {
  const {
    label = undefined,
    selected = false,
    showIcon = false,
    onClick = undefined,
    className = '',
  } = props

  const classNames = `${styles.root} ${showIcon ? styles['root--closable'] : ''} ${
    selected ? styles['root--selected'] : ''
  }  ${className}`


  const getContent = () => (
    <>
      {!!label && <span className={styles.label}>{label}</span>}
      {showIcon && (
        <span className={styles.close}>
          <Close />
        </span>
      )}
    </>
  )

  return onClick ? (
    <button type="button" className={classNames} onClick={onClick}>
      {getContent()}
    </button>
  ) : (
    <div className={classNames}>{getContent()}</div>
  )
}

export default Chip
